//
//  PasswordInput.tsx
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: October 17, 2026
//  Author: Bob Keathley
//
//  Password input with a Show/Hide toggle. Passes all normal input props through.
//  The toggle is type=button, so it can never submit the form.
//
import { useState, type InputHTMLAttributes } from 'react'

/**
 * A password field with a Show/Hide button beside the text. Passes every normal input prop through
 * (`id`, `name`, `autoComplete`, `required`, `value`/`onChange`, …) and only owns `type`. The toggle is
 * `type="button"`, so it can never submit the form, and it is reachable with the keyboard.
 */
export default function PasswordInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [shown, setShown] = useState(false)
  const { style, ...rest } = props
  return (
    <div style={{ position: 'relative' }}>
      <input {...rest} type={shown ? 'text' : 'password'} style={{ ...style, paddingRight: 64 }} />
      <button
        type="button"
        className="btn ghost sm"
        aria-label={shown ? 'Hide password' : 'Show password'}
        aria-pressed={shown}
        onClick={() => setShown((s) => !s)}
        style={{ position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)' }}
      >
        {shown ? 'Hide' : 'Show'}
      </button>
    </div>
  )
}
